import axios from 'axios';

const archiver = axios.create({
    baseURL: process.env.REACT_APP_ARCHIVER
});

// Add an interceptor to include the authorization header in all requests
archiver.interceptors.request.use((config: any) => {
    const savedToken = window.localStorage.getItem('dbmar-token');
    if (savedToken) {
        config.headers.Authorization = `Basic ${savedToken}`;
    }
    return config;
});

export default archiver;
